import { Component } from '@theme/component';

export class AnnouncementBar extends Component {
  connectedCallback() {
    super.connectedCallback();

    const container =
      this.refs.slideshowContainer ||
      this.querySelector('.announcement-bar__slides');

    if (!container || container.dataset.annabMarquee === 'true') return;

    container.querySelectorAll('[aria-hidden]').forEach((slide) => {
      slide.setAttribute('aria-hidden', 'false');
    });

    const original = container.innerHTML;

for (let i = 0; i < 8; i++) {
  container.innerHTML += original;
}

    container.dataset.annabMarquee = 'true';
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
